import { defineStore } from 'pinia'
import Api from '../api/Api'

export const useLabelStore = defineStore('label', {
  state: () => ({
    labels: [],
    categories: [],
    activeCategoryId: null,
  }),
  getters: {
    getCategories: function(state) {
      return state.categories;
    },
    getLabels: function(state) {
      return state.labels;
    },
    getActiveCategoryId: function(state) {
      return state.activeCategoryId;
    }
  },
  actions: {
    resetLabels() {
      this.labels = [];
    },
    setActiveCategoryId(categoryId) {
      this.activeCategoryId = categoryId;
    },
    refreshLabels: async function(payload) {
      const response = await Api.label.getLabels(payload);
      this.labels = response.data;
    },
    refreshCategories: async function(payload) {
      const response = await Api.label.getCategories(payload);
      this.categories = response.data;
      return response.data;
    },
    createCategory: async function( payload) {
      const response = await Api.label.createCategory(payload);
      return response.data;
    },
    updateCategory: async function(payload) {
      const response = await Api.label.updateCategory(payload);
      return response.data;
    },
    deleteCategory: async function(payload) {
      const response = await Api.label.deleteCategory(payload);
      return response.data;
    },
    createLabel: async function(payload) {
      const response = await Api.label.createLabel(payload);
      return response.data;
    },
    updateLabel: async function(payload) {
      const response = await Api.label.updateLabel(payload);
      return response.data;
    },
    deleteLabel: async function(payload) {
      const response = await Api.label.deleteLabel(payload);
      return response.data;
    },
    async fetchLabels(payload) {
      const response = await Api.label.getLabels(payload);
      return response.data;
    },
    async addMetaLabels(payload) {
      const response = await Api.label.addMetaLabels(payload);
      return response.data;
    },
    findLabels(payload) {
      return Api.label.findLabels(payload);
    }
  }
});
